<template>
    <div>
        <CookingCommentHistory />
    </div>
</template>

<script>
    // @ is an alias to /src
    //import Header from '@/app/components/Header.vue'
    import CookingCommentHistory from '@/app/components/CookingCommentHistory'

    export default {
        name: 'CookingCommentHistoryIndex',
        components: {
            CookingCommentHistory
        }
    }
</script>
